/**
 * 製品名に由来する全トークンの単一定義点（coding.md §Naming & single definition point）。
 *
 * 他のどのファイルも製品名・接頭辞のリテラルを持たない。CSS（client/assets/）は
 * CSS_PLACEHOLDERS のプレースホルダで書き、ビルド時にここの値へ置換される。
 * 改名は本ファイルの書き換えだけで完結する。
 */

/** グローバルオブジェクト名（IIFE の globalName・window への公開名） */
export const GLOBAL_NAME = 'Edge4Ebook';

/** 散文・UI 文言で使うブランド表記 */
export const BRAND_NAME = 'edge4eBook';

/** 配布ファイル名に使う小文字スラッグ */
export const DIST_SLUG = 'edge4ebook';

/** 短接頭辞（CSS クラス・data 属性・CSS カスタムプロパティの語幹） */
export const SHORT_PREFIX = 'e4b';

/** CSS クラス接頭辞 */
export const CSS_PREFIX = `${SHORT_PREFIX}-`;

/** data 属性接頭辞 */
export const DATA_PREFIX = `data-${SHORT_PREFIX}-`;

/** CSS カスタムプロパティ接頭辞 */
export const CSS_VAR_PREFIX = `--${SHORT_PREFIX}-`;

/** CSS クラス名を組み立てる（例: cls('toolbar') → e4b-toolbar） */
export function cls(name: string): string {
  return `${CSS_PREFIX}${name}`;
}

/** data 属性名を組み立てる（例: attr('page') → data-e4b-page） */
export function attr(name: string): string {
  return `${DATA_PREFIX}${name}`;
}

/** CSS カスタムプロパティ名を組み立てる（例: cssVar('bg') → --e4b-bg） */
export function cssVar(name: string): string {
  return `${CSS_VAR_PREFIX}${name}`;
}

/**
 * data 属性 → dataset キーの接頭辞。
 * data-e4b-page-mode は dataset.e4bPageMode として読める（DOM の camelCase 変換規則）。
 */
export const DATASET_PREFIX = SHORT_PREFIX;

/** 生成済み id の連番（1 ページに複数のビューワが載っても衝突させない）。 */
let idCounter = 0;

/**
 * 一意な DOM id を作る（例: uniqueId('panel-title') → e4b-panel-title-1）。
 * `aria-labelledby` のように**要素どうしを結ぶときだけ**使う。見た目の指定や
 * テストの取っ掛かりには使わない（そちらはクラス名が単一定義点）。
 */
export function uniqueId(name: string): string {
  idCounter += 1;
  return `${CSS_PREFIX}${name}-${idCounter}`;
}

/** ユーザーデータ（EP-1）を保存する localStorage のキー */
export const STORAGE_KEY = `${SHORT_PREFIX}:user-data`;

/**
 * 閲覧セッション（EP-6）を保存する sessionStorage のキー。
 * タブを閉じれば消える一時的な識別子で、localStorage にも Cookie にも置かない。
 */
export const VIEW_SESSION_KEY = `${SHORT_PREFIX}:view-session`;

/**
 * CSS のビルド時置換表（プレースホルダ → 実値）。
 * client/assets/*.css は接頭辞リテラルを持たず、これらのプレースホルダだけを書く。
 */
export const CSS_PLACEHOLDERS: Readonly<Record<string, string>> = {
  __PREFIX__: CSS_PREFIX,
  __VAR__: CSS_VAR_PREFIX,
  __ATTR__: DATA_PREFIX,
};
